/**
 * @file platformUtils.js
 * @description Provides utility functions for platform-wide operations
 *
 * @section Responsibilities
 * - Provide platform-wide utility functions
 * - Handle common platform operations
 * - Manage platform state helpers
 * - Process platform data transformations
 * - Handle platform error cases
 * - Provide platform constants
 *
 * @section Dependencies
 * - PlatformState: Platform state management
 * - DataService: Data processing utilities
 * - ValidationService: Data validation
 * - ErrorService: Error handling
 *
 * @section Integration Points
 * - Platform API: Core platform operations
 * - State System: Platform state management
 * - Data System: Data processing
 * - Error System: Error handling
 *
 * @section State Management
 * - platformState: Platform status
 * - dataState: Data processing state
 * - errorState: Error handling state
 * - validationState: Validation status
 *
 * @section Events
 * - onStateChange: State updates
 * - onDataProcess: Data processing
 * - onValidation: Data validation
 * - onError: Error handling
 *
 * @section Exports
 * @export {Object} platformUtils - Platform utility functions
 * @export {Function} processPlatformData - Data processing function
 * @export {Function} validatePlatformState - State validation
 * @export {Function} handlePlatformError - Error handling
 */

export const mapHistoricalToLineChart = (historicalList = []) => {
  const data =
    historicalList.map(({ totalEquity, date }) => {
      return {
        name: date,
        Performance: totalEquity,
      };
    }) || [];

  const minEquity = Math.min(...data.map((d) => d.Performance));
  const maxEquity = Math.max(...data.map((d) => d.Performance));

  return { data, minEquity, maxEquity };
};
